import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_User = _resolveComponent("User")!
  const _component_Repos = _resolveComponent("Repos")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Loading, {
      class: _normalizeClass({
      hide: _ctx.$store.getters.getAllRequests == _ctx.$store.getters.getDoneRequests,
    })
    }, null, 8, ["class"]),
    _createElementVNode("div", _hoisted_1, [
      (_ctx.params.chart != 'true')
        ? (_openBlock(), _createBlock(_component_User, {
            key: 0,
            username: _ctx.params.username
          }, null, 8, ["username"]))
        : _createCommentVNode("", true),
      _createVNode(_component_Repos, { params: _ctx.params }, null, 8, ["params"])
    ])
  ], 64))
}